import axios from 'axios';

import { ResponseData } from '../types/api/ResponseData';

export interface AccountAccessStatusDTO {
  locked: boolean;
  changedAt?: number;
  changedBy?: string;
}

const BASE = '/v2/admin-fusionauth-account-access';

class AdminFusionAuthAccountAccessService {
  static async getStatus(userId: number): Promise<ResponseData<AccountAccessStatusDTO>> {
    return axios.get(`${BASE}/${userId}/status`);
  }

  static async lock(userId: number): Promise<void> {
    return axios.post(`${BASE}/${userId}/lock`);
  }

  static async unlock(userId: number): Promise<void> {
    return axios.post(`${BASE}/${userId}/unlock`);
  }
}

export { AdminFusionAuthAccountAccessService };
